module.exports = __webpack_public_path__ + "static/media/logo.118ebb9c.png";